<div class="no-records-found">
  <mat-icon svgIcon="not-found"></mat-icon>
  <h3>Sorry we couldn’t find any matches for <b>Entag</b></h3>
  <h5>Please try searching with another term</h5>
</div>
